/* eslint-disable @typescript-eslint/no-explicit-any */
import { generateUuid } from '@packages/shared/core/common/utils/generateUuid';
import { HttpRequestConfig } from '../core/HttpClient';
import { HttpClientDecorator } from '../core/HttpClientDecorator';

export class WithRequestId extends HttpClientDecorator {
  get<ResponseData = any, ResponseMeta = any>(
    url: string,
    config: HttpRequestConfig = {},
  ): Promise<{ data: ResponseData; meta: ResponseMeta; success: boolean }> {
    return super.get<ResponseData, ResponseMeta>(url, this.addRequestIdToConfig(config));
  }

  post<ResponseData = any, ResponseMeta = any>(
    url: string,
    config: HttpRequestConfig = {},
  ): Promise<{ data: ResponseData; meta: ResponseMeta; success: boolean }> {
    return super.post<ResponseData, ResponseMeta>(url, this.addRequestIdToConfig(config));
  }

  put<ResponseData = any, ResponseMeta = any>(
    url: string,
    config: HttpRequestConfig = {},
  ): Promise<{ data: ResponseData; meta: ResponseMeta; success: boolean }> {
    return super.put<ResponseData, ResponseMeta>(url, this.addRequestIdToConfig(config));
  }

  private addRequestIdToConfig(config: HttpRequestConfig = {}): HttpRequestConfig {
    return {
      ...config,
      headers: {
        ...config.headers,
        'x-request-id': generateUuid(),
      },
    };
  }
}
